import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=0af7859f"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"
import style0 from "./BannerList.vue?vue&type=style&index=0&id=0af7859f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports